import {createReducer} from '@reduxjs/toolkit';
import setAreaCoverage from '../actions/set-area-coverage.js';

export default createReducer(0.8, builder => {
  builder.addCase(setAreaCoverage, (state, {payload}) => payload);
});
